import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
// import {Logo} from '../components/Logo';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Process', href: '/process' },
    { name: 'FREE assessment', href: '/technical-assessment', button: true }
  ];

  return (
    <nav className="fixed top-6 left-1/2 -translate-x-1/2 z-50 w-full px-4">
      <div className="container rounded-2xl backdrop-blur-xl border border-accent/40 shadow-2xl flex items-center justify-between h-16">
        <div className="flex-1 flex items-center justify-between">
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-white">
              {/* <Logo variant="light" width="120px" height="40px" /> */}
              nautdigital
            </Link>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={
                    item.button
                      ? "bg-accent hover:bg-accent/80 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all shadow-lg hover:shadow-accent/50"
                      : "text-gray-200 hover:text-accent px-3 py-2 rounded-md text-sm font-medium transition-colors"
                  }
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-accent hover:bg-dark/60 focus:outline-none backdrop-blur"
            aria-controls="mobile-menu"
            aria-expanded={isOpen}
            aria-label={isOpen ? 'Close main menu' : 'Open main menu'}
          >
            <span className="sr-only">{isOpen ? 'Close main menu' : 'Open main menu'}</span>
            {isOpen ? (
              <XMarkIcon className="block h-6 w-6" />
            ) : (
              <Bars3Icon className="block h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div id="mobile-menu" className="container rounded-2xl backdrop-blur-xl border-t border-accent/40 shadow-2xl mt-2 px-4 pb-4 md:hidden">
          <div className="pt-2 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-gray-200 hover:text-accent block px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 